import * as NetworkUtilities from "./networkUtilities";
import { constants } from "../constants";
/* eslint-disable import/prefer-default-export */
export function sendErrorEmail(soConfigs = {}, persistReducer = {}, errorModule = {}, apiMethod = "") {
  if (soConfigs && persistReducer && errorModule) {
    const errorModuleItem = soConfigs?.errorNotificationEmailSettings.find((emailSettings) => emailSettings.emailCategory === "TechnicalOrBusinessErrors");
    if (errorModuleItem) {
      const dateString = new Date().toUTCString();
      const emailSubject = `Error on My WV App - ${persistReducer?.selectedSOData?.soCode} | ${dateString}`;
      const errorArray = [
        {
          item: "Error Code",
          description: errorModule?.data?.status || errorModule?.statusCode,
        },
        {
          item: "Error Message",
          description: errorModule?.data?.title || errorModule?.statusMessage,
        },
        {
          item: "Error Source",
          description: apiMethod,
        },
        {
          item: "Supporter ID",
          description: persistReducer?.sponsorID,
        },
        {
          item: "Error DateTime UTC",
          description: dateString,
        },
      ];
      const reqBody = {
        emailFrom: errorModuleItem?.emailFrom,
        emailTo: errorModuleItem?.emailTo,
        //emailTo: "jyoti.gupta3@cognizant.com, Ashutosh.Joshi2@cognizant.com",
        emailCc: errorModuleItem?.emailCc,
        subject: emailSubject,
        errorDetailsList: errorArray,
      };
      const requestPayload = {
        baseURL: soConfigs?.soBaseUrl ? soConfigs?.soBaseUrl : constants.currentOrigin+"WVMobileStgAppAPI/api/v1/",
        //baseURL: soConfigs?.soBaseUrl,
        reqBody,
        reqHeaders: NetworkUtilities.GetNetWorkHeaders(persistReducer),
      };
      return requestPayload;
    }
  }
  return null;
}
